/**
 * Service to load script resources
 */
class Script {
  /** Fetches a single script */
  fetch(url: string, async = true, crossorigin = false): Promise<unknown> {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.onload = resolve;
      script.onerror = reject;
      script.async = async;
      if (crossorigin) {
        script.setAttribute('crossorigin', '');
      }
      script.src = url;
      document.body.appendChild(script);
    });
  }

  /** Fetches multiple scripts in parallel */
  fetchAll(urls: string[], async = true, crossorigin = false): Promise<unknown> {
    if (!Array.isArray(urls)) {
      throw new Error('Array error!');
    }

    return Promise.all(urls.map(url => this.fetch(url, async, crossorigin)));
  }
}

export default new Script();
